import { createWebHistory, createRouter } from "vue-router";
import Notfound from "@/components/Notfound.vue";
const Guestpage = () => import("@/components/Guestpage.vue");
const CaseStudyPage = () => import("@/components/CaseStudyPage.vue");
const BlogPlaceholder = () => import("@/components/BlogPlaceholder.vue");
const Login = () => import("@/auth/Login.vue");
const Signup = () => import("@/auth/Signup.vue");

const routes = [
  {
    path: "/",
    name: "Guest",
    component: Guestpage,
    meta: {
      title: "Jerald Pamugas | Senior Full Stack Software Engineer",
      description:
        "Senior Full Stack Software Engineer specializing in enterprise applications, business process automation, and digital transformation."
    }
  },
  {
    path: "/case-studies/:slug",
    name: "CaseStudyPage",
    component: CaseStudyPage,
    meta: {
      title: "Case Study | Jerald Pamugas",
      description:
        "Enterprise software case study covering business challenge, architecture, responsibilities, and delivery outcomes."
    }
  },
  {
    path: "/blog",
    name: "Blog",
    component: BlogPlaceholder,
    meta: {
      title: "Engineering Notes | Jerald Pamugas",
      description: "Technical notes on enterprise delivery, automation, and software architecture."
    }
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
  {
    path: "/:catchAll(.*)",
    component: Notfound,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }

  const descriptionContent =
    (to.meta && to.meta.description) ||
    "Senior Full Stack Software Engineer specializing in enterprise applications, business process automation, and digital transformation.";

  let descriptionTag = document.querySelector('meta[name="description"]');
  if (!descriptionTag) {
    descriptionTag = document.createElement("meta");
    descriptionTag.setAttribute("name", "description");
    document.head.appendChild(descriptionTag);
  }
  descriptionTag.setAttribute("content", descriptionContent);
});

export default router;
